import EditSchoolModal from "./EditSchoolModal";

export default EditSchoolModal;
